var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from "react";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
export var usePlanData = function (setDataFormBusiness, businessType) {
    var plan = useState(findParamInLocalStorage("Plan"))[0];
    var productCode = useState(findParamInLocalStorage("productCode", "steps"))[0];
    var _a = useState(false), isCommerce = _a[0], setIsCommerce = _a[1];
    var _b = useState(""), planCode = _b[0], setPlanCode = _b[1];
    useEffect(function () {
        var _a;
        if (plan) {
            var isCommerceValue = plan.name.toLowerCase().includes("comercio");
            setIsCommerce(isCommerceValue);
            var businessTypeName_1 = isCommerceValue ? "Comercial" : "Servicios";
            var businessTypeItem_1 = businessType.find(function (item) { return item.name.toLowerCase() === businessTypeName_1.toLowerCase(); });
            setDataFormBusiness(function (prev) { return (__assign(__assign({}, prev), { propertyTypeId: businessTypeItem_1 === null || businessTypeItem_1 === void 0 ? void 0 : businessTypeItem_1.id })); });
            setPlanCode((_a = plan.code) !== null && _a !== void 0 ? _a : "");
        }
    }, [plan, businessType]);
    return {
        plan: plan,
        productCode: productCode,
        isCommerce: isCommerce,
        planCode: planCode,
    };
};
